// Inline SVG glyphs for widget chrome. Charter law: no emojis — icons are
// hand-built SVG in the hairline aesthetic (thin strokes, currentColor ink
// so they follow the button's own text color and theme).

const SVG_NS = "http://www.w3.org/2000/svg";

/**
 * Close glyph: a thin cross, replacing the historical "[x]" text form on
 * every close control (operator direction 2026-07-14). Decorative —
 * identity comes from the button's aria-label ("close <surface>").
 */
export function closeIcon(): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("viewBox", "0 0 12 12");
  svg.setAttribute("width", "10");
  svg.setAttribute("height", "10");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  for (const d of ["M2 2 L10 10", "M10 2 L2 10"]) {
    const path = document.createElementNS(SVG_NS, "path");
    path.setAttribute("d", d);
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-width", "1.5");
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("fill", "none");
    svg.append(path);
  }
  return svg;
}
